import { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";
import BookCard from "../../Common/Card/BookCard/BookCard";
import Styles from "./Styles/Mybooks.module.css";
import { toast } from "react-hot-toast";
import { getMyBooks } from "../../../Services/getData";
import { likePost, saveBook } from "../../../Services/usersService";

const Mybooks = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const [books, setBooks] = useState([]);
  const [error, setError] = useState("");
  const history = useHistory();

  if (!isLoggedIn) {
    history.replace("/");
    toast.error(
      "برای استفاده از کتابخانه دیجیتال ابتدا وارد حساب کاربری خود شوید"
    );
  }

  useEffect(() => {
    const api = async () => {
      try {
        //! change this api to myBooks
        const booksList = await getMyBooks();
        setBooks(booksList.data.myBooks);
      } catch (ex) {
        setError(ex.response.data.message);
      }
    };
    api();
  }, []);

  const handleLikePost = (id) => {
    const data = { type: "book", id };
    toast.promise(likePost(data), {
      loading: "درحال اجرای عملیات . . .",
      success: (res) => {
        return res.data.message;
      },
      error: (res) => res.response.data.message,
    });
  };

  const handleChangePosts = (post) => {
    const copybooks = [...books];
    const filteredBooks = copybooks.filter((i) => i.category === post.category);
    setBooks(filteredBooks);
    toast.success(`لیست کتابها بر اساس ${post.category} بروزرسانی شد`);
    return;
  };

  const handleShareBook = (address) => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        toast.success(
          "آدرس کتاب در کلیپبورد شما ذخیره شد میتوانید به اشتراک بگذارید"
        );
      })
      .catch((err) => {
        toast.error("خطا در ذخیره آدرس در کلیپبورد:", err);
      });
  };

  const handleAddToCard = () => {
    if (!isLoggedIn) {
      toast.error("برای خرید لطفا ابتدا وارد حساب کاربر خود شوید");
    } else {
    }
  };

  const handleSaveBook = (bookId) => {
    const data = { bookId };
    if (isLoggedIn) {
      toast.promise(saveBook(data), {
        loading: "در حال ذخیره سازی کتاب . . .",
        success: (res) => res.data.message,
        error: (res) => res.response.data.message,
      });
      return;
    }
    toast.error("برای ذخیره کتاب ابتدا وارد حساب کاربری خود شوید");
  };

  return (
    <div className={Styles.container}>
      {books.length === 0 ? (
        <div className={Styles.emptyContainer}>{error}</div>
      ) : (
        books.map((item, index) => (
          <BookCard
            item={item}
            key={index}
            handleChangePosts={handleChangePosts}
            handleLikePost={handleLikePost}
            handleShareBook={handleShareBook}
            handleAddToCard={handleAddToCard}
            handleSaveBook={handleSaveBook}
            index={index}
          />
        ))
      )}
    </div>
  );
};

export default Mybooks;
